import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { interval, map, Observable, shareReplay } from 'rxjs';
import { SharedService } from '../../_services/shared.service';
import { LxResponsiveClassDirective } from '../../directives/lx-responsive-class.directive';
import { LxViewportDirective } from '../../directives/lx-viewport.directive';
import { ThemeService } from '../../_services/theme.service';

interface timeComponents {
  secondsToDday: number;
  minutesToDday: number;
  hoursToDday: number;
  daysToDday: number;

  secondsString: string;
  minutesString: string;
  hoursString: string;
  daysString: string;

}

@Component({
    selector: 'app-count-down-timer',
    standalone: true,
    imports: [CommonModule, LxResponsiveClassDirective],
    templateUrl: './count-down-timer.component.html',
    styleUrl: './count-down-timer.component.scss'
})
export class CountDownTimerComponent {


  @Input()
  title: string = 'Offer Expires In:';

  @Input()
  endDate: Date = new Date(new Date().setDate(new Date().getDate() + 1)); // Default to tomorrow

  expired: boolean = false;

  public timeLeft$: Observable<timeComponents>;

  constructor(
    public sharedService: SharedService,
    public themeService: ThemeService) {
    this.timeLeft$ = interval(1000).pipe(
      map(x => this.calcDateDiff()),
      shareReplay(1)
    );
  }

  calcDateDiff(): timeComponents {
    const dDay = this.endDate.valueOf();
    const milliSecondsInASecond = 1000;
    const hoursInADay = 24;
    const minutesInAnHour = 60;
    const secondsInAMinute = 60;
    const timeDifference = Math.max(dDay - (Date.now()), 0);

    const daysToDday = Math.floor(
      timeDifference /
        (milliSecondsInASecond * minutesInAnHour * secondsInAMinute * hoursInADay)
    );

    const hoursToDday = Math.floor(
      (timeDifference /
        (milliSecondsInASecond * minutesInAnHour * secondsInAMinute)) %
        hoursInADay
    );

    const minutesToDday = Math.floor(
      (timeDifference / (milliSecondsInASecond * minutesInAnHour)) %
        secondsInAMinute
    );

    const secondsToDday =
      Math.floor(timeDifference / milliSecondsInASecond) % secondsInAMinute;

    let secondsString: string = secondsToDday.toString();
    let minutesString = minutesToDday.toString();
    let hoursString = hoursToDday.toString();
    let daysString = daysToDday.toString();

    if(secondsToDday <= 9) {
      secondsString = "0" + secondsString;
    } else if(minutesToDday <= 9){
      minutesString = "" + minutesString;
    } else if(hoursToDday <= 9) {
      hoursString = "" + hoursString;
    }
    else if(daysToDday <= 9) {
      daysString = "" + daysString;
    }


    if(timeDifference === 0){
      this.title = 'Offer Expired:';
      this.expired = true;
      return { secondsToDday: 0, minutesToDday: 0, hoursToDday: 0, daysToDday: 0,
              secondsString: " 0", minutesString: " 0", hoursString: " 0", daysString: " 0"
       };

    } else {
      this.title = 'Offer Expires In:';
      this.expired = false;
      return { secondsToDday: secondsToDday, minutesToDday: minutesToDday, hoursToDday: hoursToDday, daysToDday: daysToDday,
              secondsString: secondsString, minutesString: minutesString, hoursString: hoursString, daysString: daysString

       };
    }
  }

}
